import { render, staticRenderFns } from "./MyDataRecords.vue?vue&type=template&id=815f4f42"
import script from "./MyDataRecords.vue?vue&type=script&lang=js"
export * from "./MyDataRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports